// extracted by mini-css-extract-plugin
export default {"wrapper":"IQ-z","availablePromoMessagesLabel":"JQ-z","promoMessageList":"KQ-z","promoMessage":"LQ-z","appliedPromoMessage":"MQ-z","promoMessageAmount":"NQ-z"};